module.exports = __webpack_public_path__ + "img/846.0bfba3fd.gif";